<template>
  <div>
    <div class="sub_wrapper">
      <div class="banner_wrap">
        <div class="b_cont">
          <div class="b_ss_wrap">
            <input type="text" placeholder="请输入搜索关键字" v-model="input" class="ipt_txt"/>
            <button class="ss_btn" @click="toSearch">搜 索</button>
          </div>
        </div>
      </div>
      <div class="main_wrap w_1200">
        <div>
          <FilterGroup @change="changeSearch">
          <!--  <FilterCheckBoxMine
              ref="FilterCheckBoxMine1"
              v-model="searchInfo.data.dq"
              label="政策级别"
              :list="getDictList('policy_level')"
              valueKey="key"
              :needAll="true"
              fold
            ></FilterCheckBoxMine>-->
            <!-- 行政区划 -->
            <FilterItemCheck
              ref="FilterCheckBoxMine3"
              v-model="searchInfo.data.areacode"
              label="行政区划"
              :list="areaList"
              valueKey="value"
              labelKey="label"
              :needAll="true"
              fold
            ></FilterItemCheck>
            <!-- 主管部门 -->
            <FilterItemCheck
              ref="FilterCheckBoxMine3"
              v-model="searchInfo.data.deptcode"
              label="主管部门"
              :list="hydlList"
              valueKey="deptId"
              labelKey="deptName"
              :needAll="true"
              fold
            ></FilterItemCheck>
            <FilterCheckBoxMine
              v-model="labelList"
              label="热门标签"
              :list="newHotLabel"
              valueKey="labelKey"
              labelKey="labelValue"
              fold
            ></FilterCheckBoxMine>
          </FilterGroup>
        </div>
        <div class="zc_wrap clearFloat" style="margin-top: 50px;">
          <div class="zc_left fl">
            <div class="title_01">
              <div class="tit_txt">政策文件</div>
              <div class="tit_r">
                <ul class="tab_tit tab_tit03">
                  <li class="item" :class="{'active':sortByType == 0}" @click="groupTimeGX()">按更新时间排序</li>
                  <li class="item" :class="{'active':sortByType == 1}" @click="groupTimeFB()">按发布时间排序</li>
                </ul>
                <div class="txt">为您找到<span>{{ total }}</span>个相关信息</div>
              </div>
            </div>
            <ul class="result_list result_list3" style="min-height:200px;">
              <li v-for="(item, i) in tableData" :key="i" @click="toPolicyDetail(item)">
                <a href="#" class="li_tit slh">
                  <span v-show="item.deptName">[{{ item.deptName }}]</span>
                  {{ item.title || item.name }}{{ item.title || item.name }}
                </a>
                <div class="li_ms">
                  <span><img :src="require('@/assets/newStyle/images/time_icon.png')">{{ item.publictime.substr(0, 10) }}</span>
                  <span><img :src="require('@/assets/newStyle/images/hao_icon.png')">{{ item.fwzh }}</span>
                </div>
                <div class="li_wj"><img :src="require('@/assets/newStyle/images/doc_icon.png')"/></div>
              </li>
            </ul>
            <div class="page_row">
              <el-pagination
                v-if="pageshow && total"
                style="margin: 10px auto;"
                background
                :page-size="pageSize"
                layout="prev, pager, next,total, jumper"
                prev-text="上一页"
                next-text="下一页"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="CurrentChange"
              >
              </el-pagination>
            </div>
          </div>
          <div class="zc_right fr">
            <div class="title_01">
              <div class="tit_txt">热搜关键词</div>
            </div>
            <div class="zc_r_cont">
              <div style="margin-top: 20px">
              <el-radio-group
                v-model="input"
                size="medium"
                @change="(val) => radioChange(val, 'radioKeyWord')"
              >
                <el-radio-button
                  v-for="item in radioKeyWordData"
                  :key="item.word"
                  :label="item.word"
                ></el-radio-button>
              </el-radio-group>
            </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
const tableData = [];
import { mapGetters } from "vuex";
import {
  FilterGroup,
  // FilterRadio,
  FilterCheckBoxMine,
  // FilterItem,
  FilterItemCheck,
} from "./components/filter/index.js";
export default {
  name: "showPolicy",
  components: {
    FilterGroup,
    // FilterRadio,
    FilterCheckBoxMine,
    // FilterItem,
    FilterItemCheck,
  },
  props: {},
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      getDictList: "dictionary/getDictList",
      getDictLabel: "dictionary/getDictLabel",
    }),
  },
  data() {
    return {
      pageshow: true,
      defaultProps: {
        children: "children",
        label: "labelname",
      },
      treeData: [],
      checkList: [],
      activeIndex: "",
      cascaderValue: [],
      labelList: [], //标签名
      total: 0,
      pageSize: 10,
      checkListDq: [],
      labelData: [],
      newHotLabel: [],
      activeNames: [0],
      radioKeyWord: "",
      radioKeyWordData: [],
      radioAll: "",
      radioTaxKind: "",
      radioYear: "",
      isActive: 0,
      menu: ["全部", "按税种查询", " 按年份查询"],
      all: [
        "税费政策",
        "人才支持",
        "知识产权",
        "营商环境",
        "民营经济",
        "房租减免",
      ],
      taxKind: ["增值税", "消费税", "企业所得税", "个人所得税"],
      year: ["2021", "2020", "2019", "2018"],
      tableData,
      input: "",
      // 搜索条件
      searchInfo: {
        data: {
          rmtag: "", //热门标签
          xmlb: "", // 项目类别
          cylb: "", // 产业类别
          deptcode: "", // 发布部门
          areacode: "", // 发布部门
          zcfs: "", // 支持方式
          temp_amount: "", // 资金限额
          zzxeleft: "", // 起始资金限额
          zzxeright: "", // 结束资金限额
          name: "", // 事项名称
          hyle: "", //行业类别
          zcfl: "", //政策分类
          dq: "", //地区
          qysx: "", //企业属性
          qygm: "", //企业规模
          growth: "", //成长周期
        },
        oldParams: {},
        deptList: [], // 职能部门列表
        amountList: [
          { value: "0", label: "1000万及以上" },
          { value: "1", label: "500万~1000万" },
          { value: "2", label: "100万~500万" },
          { value: "3", label: "100万及以下" },
          // { value: '4', label: '自定义' },
        ],
        areaList: [], //地区列表
        type: "0", // 搜索类型{'0':传统列表, '1':数字化列表}
      },
      searchDataHyle: "", //搜索行业类别需要的数据
      searchDataZcfl: "", //搜索政策分类需要的数据
      searchDataDq: "", //搜索地区需要的数据
      searchDataAreaId: "", //搜索部门
      searchDataDept: "", //搜索部门需要的数据
      searchDataQysx: "", //搜索企业属性需要的数据
      searchDataQygm: "", //搜索企业规模需要的数据
      searchDataGrowth: "", //搜索成长周期需要的数据
      areaValue: [], //政策级别名称
      enterpriseAttributesValue: [], //企业属性
      enterpriseSizeValue: [], //企业规模
      growthCycleValue: [], //成长周期
      sysCategoryValue: [], //行业类别
      deptName: [], //主管部门需要传的参数数据
      hydlList: [], //主管部门
      areaList: [], //行政区划
      policyClassificationValue: [], //政策分类需要传的参数数据
      typeTagData: [], // 类型及标签数据
      typeTagDataCheckedDept: [], // 选择了主管部门的类型及标签数据
      labelItem2: [], // 第二级标签的值
      showLabel2Status: false,
      sortByType: 1, //  0 是更新时间排序    1是发布时间排序
      clickTagName: "", // 存储点击三级的政策标签
      clickLevel2TagName: "", // 存储点击二级的政策标签
      checkboxGroupLevel3: [], //三级标签双向绑定
      checkboxGroupLevel2: [], //级标签双向绑定
      hotTagFlag: false, //点击了热词标签为true
      label2MarginTop: "0", // label2样式
      areaCodeValue: [], //选中的行政区划code
    };
  },
  created() {
    this.queryTypeAndTag();
    this.getDeptList();
    this.getAreaList();
    this.userInfo;
    this.getProjectLibrary(1);
    this.getAllLabel();
    //this.queryLabelDept();
    this.getBqHotList();
    this.getNewHotLabelList();
    this.$store.dispatch("dictionary/commonSetDic", {
      types: [
        "sq_policy_xmlb",
        "sys_enter_type",
        "sq_policy_zjlx",
        "permit_sertype", // 办理对象
        "sys_enterprise_registertype", // 注册类型
        "sys_category", // 行业类别(国民经济分类)
        "policy_level", //政策层级
        "enterprise_attributes", //企业属性
        "enterprise_size", //企业规模
        "growth_cycle", //成长周期
      ],
    });
  },
  mounted() {},
  methods: {
    //
    flatTree(data) {
      let arr = [];
      for (let i = 0; i < data.length; i++) {
        arr.push(data[i].labelcode);
        // if(data[i].children&&data[i].children.length!=0){
        //   return this.flatTree(data[i].children);
        // }
      }
      return arr;
    },
    renderContent(h, { node, data }) {
      if (this.checkList.indexOf(node.data.labelcode) != -1) {
        return <span class="checkedStyle">{data.labelname}</span>;
      } else {
        return <span style="font-size:18px;">{data.labelname}</span>;
      }
      // let arr = this.treeData
    },
    treeCheck(checkedNodes, checkedKeys) {
      this.checkList = checkedKeys.checkedKeys;
      //this.renderContent();
      this.labelList = [];
      checkedKeys.checkedNodes.forEach((item) => {
        this.labelList.push({
          labelKey: item.labelcode,
          labelValue: item.labelname,
        });
      });
      if (this.labelList.length == 0) {
        this.getProjectLibrary(1);
      } else {
        this.getTagPolicy(1);
      }
    },
    groupTimeFB() {
      this.sortByType = 1;
      if (this.labelList.length > 0) {
        this.getTagPolicy(1);
      } else {
        this.getProjectLibrary(1);
      }
    },
    groupTimeGX() {
      this.sortByType = 0;
      if (this.labelList.length > 0) {
        this.getTagPolicy(1);
      } else {
        this.getProjectLibrary(1);
      }
    },
    hiddenLabel2() {
      this.showLabel2Status = false;
    },
    cpu_paramsList() {
      let list = [];
      // 政策级别
      if (this.searchDataDq) {
        let arrData = [];
        let listlabel = [];
        let listvalue = [];
        if (this.searchDataDq !== "") {
          arrData = this.searchDataDq.split(",");
          arrData.forEach((item) => {
            listvalue.push(item);
            let label = this.getDictList("policy_level").find(
              (cv) => cv.key === item
            )?.label;
            listlabel.push(label);
            //this.areaValue.push(label)
          });
          list.push({
            type: "dq",
            value: listvalue.join("，"),
            label: listlabel.join("，"),
          });
        }
      }
      //主管部门
      if (this.searchDataDept) {
        let arrData = [];
        let listlabel = [];
        let listvalue = [];
        if (this.searchDataDept !== "") {
          arrData = this.searchDataDept.split(",");
          arrData.forEach((item) => {
            listvalue.push(item);
            let label = this.hydlList.find(
              (cv) => cv.deptId === item
            )?.deptName;
            listlabel.push(label);
            //this.searchDataDeptList.push(label);
          });
          list.push({
            type: "zgbm",
            value: listvalue.join("，"),
            label: listlabel.join("，"),
          });
        }
      }
      // 行政区划
      if (this.searchDataAreaId) {
        let listlabel = [];
        let listvalue = [];
        if (this.searchDataAreaId !== "") {
          listvalue.push(this.searchDataAreaId);
          let label = this.areaList.find(
            (cv) => cv.value === this.searchDataAreaId
          )?.label;
          listlabel.push(label);
          //this.searchDataDeptList.push(label);
          list.push({
            type: "xzqh",
            value: listvalue.join("，"),
            label: listlabel.join("，"),
          });
        }
      }
      // 去掉第一个逗号
      list.filter((item) => {
        if (item.label[0] == "，") {
          item.label = item.label.substring(1);
        }
      });
      this.cleanPolicyParams();
      list.forEach((item) => {
        switch (item.type) {
          case "hyle":
            this.sysCategoryValue.push(item.label);
            break;
          case "qysx":
            this.enterpriseAttributesValue.push(item.label);
            break;
          case "qygm":
            this.enterpriseSizeValue.push(item.label);
            break;
          case "growth":
            this.growthCycleValue.push(item.label);
            break;
          case "dq":
            this.areaValue.push(item.label);
            break;
          case "zcfl":
            this.policyClassificationValue.push(item.label);
            break;
          case "zgbm":
            this.deptName.push(item.label);
            break;
          case "xzqh":
            this.areaCodeValue.push(item.value);
            break;
          default:
            break;
        }
      });
      if (this.hotTagFlag == false) {
        this.getProjectLibrary(1);
      }
      return list;
    },
    toSearch() {
      this.getProjectLibrary(1);
    },
    // 清空传参
    cleanPolicyParams() {
      this.areaValue = [];
      this.enterpriseAttributesValue = [];
      this.enterpriseSizeValue = [];
      this.growthCycleValue = [];
      this.sysCategoryValue = [];
      this.policyClassificationValue = [];
      this.deptName = [];
      this.areaCodeValue = [];
    },
    // 查询主管部门的时候，政策文件左侧显示的标签
    getTags() {
      let dept = "";
      this.deptName.forEach((item) => {
        dept += item + "，";
      });
      dept = dept.substring(0, dept.length - 1);
      let params = {
        industrys: dept,
        isAll: false,
      };
      let url = `/label/warehouse/allListByIndustry`;
      let that = this;
      that.$httpApi
        .post(url, params)
        .then((res) => {
          that.typeTagDataCheckedDept = res.data;
        })
        .catch((e) => {});
    },
    // 查询政策文件
    getProjectLibrary(pageNum) {
      const loading = this.$loading({
        lock: true,
        text: "加载中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.3)",
        customClass: "loadingin",
      });
      this.tableData = [];
      if (pageNum == 1) {
        this.pageshow = false;
        this.$nextTick(() => {
          this.pageshow = true;
        });
      }
      let url = "/elastic/search/sq-policy";
      // deptName: this.deptName,
      let params = {
        pageNum: pageNum,
        pageSize: this.pageSize,
        keyWords: this.input,
        areaValue: this.areaValue,
        sortBy: this.sortByType.toString(), //  0 是更新时间排序    1是发布时间排序
        enterpriseAttributesValue: this.enterpriseAttributesValue,
        enterpriseSizeValue: this.enterpriseSizeValue,
        growthCycleValue: this.growthCycleValue,
        sysCategoryValue: this.sysCategoryValue,
        policyClassificationValue: this.policyClassificationValue,
        deptName: this.deptName,
        areaCodeValue: this.areaCodeValue,
        // deptName:this.searchDataDept
      };

      let that = this;
      that.$httpApi
        .post(url, params)
        .then((res) => {
          that.total = res.total;
          that.tableData = res.rows;
          loading.close();
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 查询标签
    getAllLabel() {
      let url = "/dev-api/enterprise-label/queryAllLabel";
      let params = {};
      let that = this;
      that.$httpApi
        .post(url, params)
        .then((res) => {
          // that.labelData = res.data;
          res.data.forEach((item, index, arr) => {
            that.labelData.push({
              labelname: item.labelname,
              labelcode: item.labelcode,
            });
            if (item.children && item.children.length != 0) {
              that.labelData["children"] = [];
              item.children.forEach((item) => {
                that.labelData.children.push({
                  labelname: item.labelname,
                  labelcode: item.labelcode,
                });
              });
              // item.children.forEach(item)
            }
          });
        })
        .catch((err) => {
          console.log("evaluate error:", err);
        });
    },
    queryTypeAndTag() {
      let params = {
        industrys: "",
        isAll: true,
      };
      let url = `/label/warehouse/allListByIndustry`;
      // let url = `/label/warehouse/list?industry=${window.encodeURI(
      //   "国家税务总局信阳市税务局"
      // )}`;
      this.$httpApi.post(url, params).then((res) => {
        if (res.code == 200) {
          this.treeData = res.data || [];
          let arr = this.flatTree(res.data);
        }
      });
    },
    // 获取热词标签
    // 热搜关键词
    getBqHotList() {
      let url = "/dev-api/system/hotWords";
      let that = this;
      let params = {};
      that.$httpApi
        .get(url, params)
        .then((res) => {
          that.radioKeyWordData = res.rows;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 热门标签
    getNewHotLabelList() {
      let url = "/dev-api/enterprise-label/queryHotLabel";
      let that = this;
      let params = {};
      that.$httpApi
        .get(url, params)
        .then((res) => {
          that.newHotLabel = res.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    //根据热门标签查询热门政策
    selectHotPolicyByHotLabel() {
      this.getTagPolicy(1);
    },
    // 根据标签查询政策
    getTagPolicy(pageNum) {
      if (pageNum == 1) {
        this.pageshow = false;
        this.$nextTick(() => {
          this.pageshow = true;
        });
      }
      let url = "/dev-api/enterprise-label/queryPolicyByLabel";
      if(this.labelList.length == 0){
        this.labelList = [{labelKey: "zzcy", labelValue: "自主创新"},
          {labelKey: "ggzlzf", labelValue: "公共租赁住房"}]
      }
      let params = {
        policyKeywordList: [],
        labelList: this.labelList,
        sortBy: this.sortByType,
        deptList: [],
        pageNum: pageNum,
        pageSize: this.pageSize,
      };
      console.log("params......",params)
      let that = this;
      that.$httpApi
        .post(url, params)
        .then((res) => {
          that.tableData = res.data.list;
          that.total = res.data.total;
        })
        .catch((e) => {});
    },
    changeSearch(label, value) {
      // 特殊情况不需要触发搜索
      this.hotTagFlag = false;
      this.queryTypeAndTag();
      switch (label) {
        case "行业类别":
          this.searchDataHyle = value;
          break;
        case "政策分类":
          this.searchDataZcfl = value;
          break;
        case "政策级别":
          // case "我要找":
          // value = value.substring(1);
          this.searchDataDq = value;
          break;
        case "行政区划":
          this.searchDataAreaId = value;
          this.searchInfo.data.deptcode = "";
          this.hydlList = [];
          // this.$refs.FilterCheckBoxMine3.cleanItem();
          this.getDeptList();
          break;
        case "主管部门":
          this.searchDataDept = value;
          break;
        // case "企业属性":
        //   this.searchDataQysx = value;
        //   break;
        // case "我是":
        case "企业规模":
          this.searchDataQygm = value;
          break;
        // case "成长周期":
        //   this.searchDataGrowth = value;
        //   break;
        case "热门标签":
          this.hotTagFlag = true;
          this.labelList = [];
          let val = value.split(",");
          this.labelData.forEach((itemOut) => {
            val.forEach((item) => {
              if (itemOut.labelcode == item) {
                this.labelList.push({
                  labelKey: item,
                  labelValue: itemOut.labelname,
                });
              }
            });
          });
          this.labelList;
          this.getTagPolicy(1);
          break;
        default:
          break;
      }
      this.cpu_paramsList();
      this.getTags();
    },
    clickLi(index) {
      this.isActive = index;
    },
    handleSizeChange() {},
    // 当前页改变时
    CurrentChange(pageNum) {
      if (this.labelList.length == 0) {
        this.getProjectLibrary(pageNum);
      } else {
        this.getTagPolicy(pageNum);
      }
    },
    // 行政区划查询
    getAreaList() {
      let url = "/cfginfo/region/cascaderTreeList";
      this.$httpApi
        .get(url, { parentid: "411500000000" })
        .then((res) => {
          // console.log('getDeptList:', res)
          if (res.data && !!res.data.length) {
            this.areaList = res.data || [];
          }
          console.log("行政区划查询" + res);
        })
        .catch((err) => {
          console.log("getAreaList error:", res);
        });
    },
    /**
     * @description 查询职能部门列表
     */
    // 主管部门
    getDeptList() {
      let url = "/system/dept/getNewDeptByAreaIds";
      let data;
      if (this.searchDataAreaId == "") {
        //如果选择不限
        data = {
          areaId: "411500000000",
        };
      } else {
        //如果有值，替换值。
        data = {
          areaId: this.searchDataAreaId,
        };
      }
      this.$httpApi
        .get(url, data)
        .then((res) => {
          if (res.data && !!res.data.length) {
            this.hydlList = res.data || [];
          } else {
            this.hydlList = res.data || [];
          }
        })
        .catch((err) => {
          console.log("getDeptList error:", res);
        });
    },
    // 主管部门
    queryLabelDept() {
      let url = "/dev-api/enterprise-label/queryLabelDept";
      let params = {};
      this.$httpApi
        .post(url, params)
        .then((res) => {
          this.hydlList = res.data;
        })
        .catch((err) => {
          console.log("evaluate error:", err);
        });
    },
    toPolicyDetail(row) {
      // this.userInfo
      // delete row.content;
      row.content2 ="";
      let data = JSON.stringify(row);
      sessionStorage.setItem("policyDetailData", data);
      window.sessionStorage.setItem("flag", false);
      window.sessionStorage.setItem("status", false);
      // this.$router.push({
      //   name: "showPolicyDetail",
      // });
      let { href } = this.$router.resolve({
        name: "showPolicyDetail",
      });
      window.open(href, "_blank");
    },
    handleChange(val) {
      console.log(val);
    },
    cleanParams() {
      this.searchDataHyle = "";
      this.searchDataZcfl = "";
      this.searchDataDq = "";
      this.searchDataDept = "";
      this.searchDataQysx = "";
      this.searchDataQygm = "";
      this.searchDataGrowth = "";
      // 清空选择的条件
      this.$refs.FilterCheckBox1.cleanItem();
      this.$refs.FilterCheckBox2.cleanItem();
      this.$refs.FilterCheckBox3.cleanItem();
      this.$refs.FilterCheckBox4.cleanItem();
      // this.$refs.FilterCheckBox5.cleanItem();
      this.cleanPolicyParams();
    },
    radioChange(val, param) {
      switch (param) {
        case "radioAll":
          this.labelList = [];
          let labelKey = "";
          this.labelData.forEach((item) => {
            if (item.labelname == val) {
              labelKey = item.labelcode;
            }
          });
          this.labelList.push({
            labelKey: labelKey,
            labelValue: val,
          });
          this.getTagPolicy(1);
          break;
        case "radioTaxKind":
          break;
        case "radioYear":
          break;
        case "radioKeyWord":
          break;
        default:
          break;
      }
      // this.getProjectLibrary();
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-radio-button--medium .el-radio-button__inner {
    background-color: #eee;
    border-radius: 30px;
    margin: 5px 10px;
    border: none;
    font-size: 18px;
    text-align: center;
  }
  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    border: none;
    box-shadow: none;
  }
   .el-radio-button.is-active .el-radio-button__inner {
    background-color:#1472FF;
  }
  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    border: none;
    box-shadow: none;
  }


}
@import "@/assets/newStyle/css/idx.scss";
@import "@/assets/newStyle/css/login.scss";

</style>
